import { useTranslation } from 'react-i18next'

import { useSignOut } from '@/shared/hooks/api/auth'
import { ConfirmDialog } from '@/components/confirm-dialog'

interface SignOutDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function SignOutDialog({ open, onOpenChange }: SignOutDialogProps) {
  const { t } = useTranslation('common')
  const signOut = useSignOut()

  const handleSignOut = () => {
    signOut.mutate()
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('profile.signOutDialogTitle')}
      desc={t('profile.signOutDialogDescription')}
      cancelBtnText={t('actions.cancel')}
      confirmText={t('actions.signOut')}
      destructive
      handleConfirm={handleSignOut}
      className='sm:max-w-sm'
    />
  )
}
